import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";

import { useProfile } from "../Components/Hooks/UserHooks";


const AuthProtected = ({ children }) => {
  const dispatch = useDispatch();
  const { userProfile, loading, token } = useProfile();

  useEffect(() => {
    if (userProfile && !loading && token) {
      // ✅ Set axios default Authorization header
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else if (!userProfile && !token) {
      // ✅ Clear axios header
      delete axios.defaults.headers.common["Authorization"];
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  if (!userProfile && !token && !loading) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export { AuthProtected };
